import axios from '../../../common/api/axios';

export const getReconcileMaterials = async ({ parent, parentId }) => {
  const response = await axios.get(`/material/${parent}/${parentId}`);

  return response.data;
};

export async function getAllProjectMaterials(projectId, setMaterials) {
  const materials = await getReconcileMaterials({
    parent: 'project',
    parentId: projectId,
  });

  setMaterials(materials);
}

export const getProjectPos = async (projectId) => {
  const response = await axios.get(`/po/project/${projectId}`);

  return response.data;
};

export async function getAllProjectPos(projectId, setPos) {
  const pos = await getProjectPos(projectId);

  setPos(pos);
}
